import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Skeleton from '@mui/material/Skeleton'
import Icon from '@mui/material/Icon'
import Chip from '@mui/material/Chip'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const ApprovalCard = ({ item, handleOpenAddNewApprovalRouteModal, onDelete }) => {
  const [menuAnchor, setMenuAnchor] = useState(null)
  const isMenuOpen = Boolean(menuAnchor)

  const handleOpenMenu = (event) => {
    event.stopPropagation()
    setMenuAnchor(event.currentTarget)
  }

  const handleCloseMenu = () => {
    setMenuAnchor(null)
  }

  const handleDelete = () => {
    handleCloseMenu()
    onDelete?.(item)
  }

  // const { layer_one : {name:name_layer_one }}  = item
  // const { layer_two : {name:name_layer_two} }  = item
  // const { layer_three : {name:name_layer_three} }  = item
  // const { layer_four : {name:name_layer_four} }  = item
  // const { layer_five : {name:name_layer_five} }  = item

  const layer2 = [
    item?.layer_one?.name,
    item?.layer_two?.name,
    item?.layer_three?.name,
    item?.layer_four?.name,
    item?.layer_five?.name,
  ]
    .filter((el) => el)
    .toString()
    .replaceAll(',', ' > ')
  // const layers = [name_layer_one, name_layer_two, name_layer_three, name_layer_four, name_layer_five ].filter(el => el).toString().replaceAll(",", " > ")
  return (
    <Box
      px={2}
      borderBottom="1px solid"
      borderBottomColor="gray-line.main"
      py={3}
      display="flex"
      flexDirection={{ xs: 'column', lg: 'row' }}
      justifyContent={{ xs: 'flex-start', lg: 'space-between' }}
      alignItems={{ xs: 'flex-start', lg: 'center' }}
    >
      <Box display="flex" minWidth={0}>
        <Box height="100%" display="flex" alignItems="center" gap={2} width="100%" maxWidth="700px">
          <Box
            height="100%"
            display="flex"
            flexDirection="column"
            alignItems="left"
            justifyContent="center"
            gap={0.5}
          >
            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
              <Typography variant="body1">{item?.name || <Skeleton width="100px" />}</Typography>
              {item?.is_used && !item?.is_deleted && (
                <Chip
                  label="In use"
                  size="small"
                  sx={{
                    bgcolor: 'warning.main',
                    color: 'dark-text.main',
                    fontWeight: 500,
                  }}
                />
              )}
            </Box>
            <Box
              color="light-gray-text.main"
              sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}
            >
              <Typography variant="body2" as="span" color="alternate.main">
                {item?.num_layers ? `${item?.num_layers} steps` : <Skeleton width="200px" />}{' '}
              </Typography>
              <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle_rounded</Icon>{' '}
              <Typography variant="body2" as="span" color="light-gray-text.main">
                {layer2}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        {/* <AdxButton variant={'ghost'} onClick={handleOpenAddNewApprovalRouteModal}>{item ? "View route" : <Skeleton width="100px"/>}</AdxButton> */}
        <Typography
          onClick={() => handleOpenAddNewApprovalRouteModal()}
          mx={2}
          noWrap
          variant="subtitle1"
          color={'alternate.main'}
          sx={{
            textDecoration: 'underline',
            fontWeight: 'medium',
            cursor: 'pointer',
          }}
        >
          View flow
        </Typography>
        {item && (
          <>
            <IconButton size="small" onClick={handleOpenMenu}>
              <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={menuAnchor} open={isMenuOpen} onClose={handleCloseMenu}>
              <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
          </>
        )}
      </Box>
    </Box>
  )
}

export default ApprovalCard
